<template>
  <div :class="$style.container">
    <div v-text="displayPaymentData"></div>
    <div
      v-if="isExternalPaymentMethod"
      :class="$style.description"
      v-text="$t('money.sent.to.your.wallet')"
    ></div>
  </div>
</template>

<script>
import { formatPaymentMethod, formatCardPsType } from 'lib/utils/cards';

import {
  DISPLAY_PAYMENT_OPTIONS_MAP,
  EXTERNAL_PAYMENT_OPTIONS
} from 'definitions/payment';

export default {
  name: 'PaymentMethod',
  props: {
    paymentMethod: {
      type: String,
      required: true,
    },
    accountNumber: String,
    cardPsType: String,
  },
  computed: {
    // Card / Google Pay / Qiwi / YooMoney/ PayMe / Yandex Pay
    displayPaymentMethod() {
      return DISPLAY_PAYMENT_OPTIONS_MAP[this.paymentMethod] || '';
    },
    displayPaymentData() {
      // Для внешних платежных систем QIWI / YOOMONEY / PAYME отображаем название платежной системы
      if (this.isExternalPaymentMethod) {
        return this.displayPaymentMethod;
      }

      // Если номер карты отсутствует отображаем отформатированное название платежной системы
      if (this.$validate.isNotString(this.accountNumber)) {
        return this.formattedCardPsType;
      }

      // Отформатированное название платежной системы и сокращенный номер платежной карты
      return formatPaymentMethod(this.accountNumber, this.formattedCardPsType);
    },
    isExternalPaymentMethod() {
      return EXTERNAL_PAYMENT_OPTIONS.includes(this.paymentMethod);
    },
    formattedCardPsType() {
      const psType = formatCardPsType(this.accountNumber, this.cardPsType, this.paymentMethod);

      return this.$validate.isString(psType) ? psType : this.displayPaymentMethod;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +font-type('medium', 20, 30)
    word-break: break-all

  .description
    +font-type('medium', 12, 18)
</style>
